import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    Box,
    Typography,
    IconButton,
    Tooltip,
    Skeleton
} from '@mui/material';
import {
    Refresh as RefreshIcon,
    Share as ShareIcon
} from '@mui/icons-material';
import UserHeader from '../../../../Components/User/UserHeader.component';

const UserPageHeader = ({ userId, loading, onRefresh }) => {
    const { t } = useTranslation();

    const handleShare = () => {
        navigator.clipboard.writeText(window.location.href);
    };

    return (
        <Box sx={{ mb: 4 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <Box>
                    {loading ? (
                        <Box>
                            <Skeleton variant="text" width={300} height={40} sx={{ mb: 1 }} />
                            <Skeleton variant="text" width={400} height={28} />
                        </Box>
                    ) : (
                        <>
                            <UserHeader userId={userId} />
                            <Typography variant="h5" color="text.secondary" sx={{ fontFamily: 'monospace' }}>
                                {userId}
                            </Typography>
                        </>
                    )}
                </Box>
                <Box sx={{ ml: 'auto', display: 'flex', gap: 1 }}>
                    {loading ? (
                        <>
                            <Skeleton variant="circular" width={40} height={40} />
                            <Skeleton variant="circular" width={40} height={40} />
                        </>
                    ) : (
                        <>
                            <Tooltip title={t('refreshData')}>
                                <IconButton onClick={onRefresh}>
                                    <RefreshIcon />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title={t('shareProfile')}>
                                <IconButton onClick={handleShare}>
                                    <ShareIcon />
                                </IconButton>
                            </Tooltip>
                        </>
                    )}
                </Box>
            </Box>
        </Box>
    );
};

export default UserPageHeader;
